import { Event } from "../common/Emitter";
import { ScadenzaDto } from "../generated";

class ExpirationsStore {
    public Changed: Event = new Event();
    private _scadenze: ScadenzaDto[];
    get scadenze() {
        if (this._scadenze == null) {
            const fromStorage = sessionStorage.getItem("ExpirationsStore");
            if (fromStorage == null)
                this._scadenze = [];
            else
                this._scadenze = JSON.parse(fromStorage);
        }
        return this._scadenze;
    }
    set scadenze(value: ScadenzaDto[]) {
        if (this._scadenze == value)
            return;

        this._scadenze = value;
        sessionStorage.setItem("ExpirationsStore", JSON.stringify(value));
        this.Changed.emit();
    }
}

export default new ExpirationsStore()
